
interface ColumnItem {
    id: number;
    name: string;
    checked: boolean;
  }

  export const initialColumnContacts = [
    { id: 1, name: 'CONTACT ID', checked: true, key:'contactRecNumber' }, 
    { id: 2, name: 'FULL NAME', checked: true, key:'fullName' }, 
    { id: 3, name: 'PHONE NUMBER', checked: true, key:'mainPhone' }, 
    { id: 4, name: 'EMAIL ADDRESS', checked: true, key:'email' }, 
    { id: 5, name: 'LOCATION', checked: true, key: 'location' }, 
    { id: 6, name: 'STATUS', checked: true, key:'status' }, 
    { id: 7, name: 'ACCOUNT', checked: false, key:'accountName' }, 
    { id: 8, name: 'CONTACT TYPE', checked: true, key:'contactType' }, 
  ];
  
